import DuesByUnit from "../../slices/finance/duesByUnit/DuesByUnit"
import FineCharges from "../../slices/finance/fineCharges/FineCharges"
import Invoice from "../../slices/finance/invoice/Invoice"
import ResidentInvoice from "../../slices/finance/invoice/ResidentInvoice"
import Payment from "../../slices/finance/payment/Payment"
import FinancialYear from "../../slices/finance/financialYear/FinancialYear"
import ExpenseBudget from "../../slices/finance/expenseBudget/ExpenseBudget"
import BudgetTracking from "../../slices/finance/budgetTracking/BudgetTracking"
import Expense from "../../slices/finance/expense/Expense"

const financeReducer = {
    duesByUnit: DuesByUnit,
    fineCharges: FineCharges,
    invoice: Invoice,
    residentInvoice: ResidentInvoice,
    payment: Payment,
    financialYear: FinancialYear,
    expenseBudget: ExpenseBudget,
    budgetTracking: BudgetTracking,
    expense: Expense,
}

export default financeReducer;
